
<template>
    <div>
      <el-drawer @reload="$reloadHandle" title="更多号码" size="45%" :before-close="handleClose" :visible.sync="drawer"
        direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">
        <div class="demo-drawer__content">
          <template>
            <div>

              <div class="detail-wrap">
                <el-form ref="editForm" :model="formData">
                  <div class="d-header">
                  </div>
                  <div class="d-cont edit-mce-box">
                    <div class="d-item">
                      <div class="title first">
                        <b><span>更多号码</span></b>
                      </div>
                      <table class="table-detail">
                        <tbody>
                          <tr style="display: block;">
                            <th>其他号码1：</th>
                            <td>{{ formData.userPhone1 }}</td>
                            <th>其他号码2：</th>
                            <td>{{ formData.userPhone2 }}</td>
                            <th v-if="formData.displayRealNumber" >虚拟号码：</th>
                            <td v-if="formData.displayRealNumber" >{{ formData.userPhoneUnreal }}</td>
                          </tr>
                          <tr style="display: block;" v-if="formData.displayRealNumber">
                            <th>其他虚拟号码1：</th>
                            <td>{{ formData.userPhoneUnreal1 }}</td>
                            <th>其他虚拟号码2：</th>
                            <td>{{ formData.userPhoneUnreal2 }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div style="height: 10px;"></div>
                  </div>
                </el-form>
              </div>
            </div>
          </template>

        </div>
      </el-drawer>
    </div>
  </template>
  <script>
  import api from "@/api/projectApi";
  export default {
    inject: ['reload'],
    name: 'familyMobileDialog',
    props: ['multi','userPhone1','userPhone2','userPhoneUnreal','userPhoneUnreal1','userPhoneUnreal2','displayRealNumber'],
    components: {
    },
    created() {
      this.formData.userPhone1 = this.userPhone1
      this.formData.userPhone2 = this.userPhone2
      this.formData.userPhoneUnreal = this.userPhoneUnreal
      this.formData.userPhoneUnreal1 = this.userPhoneUnreal1
      this.formData.userPhoneUnreal2 = this.userPhoneUnreal2
      this.formData.displayRealNumber = this.displayRealNumber
      console.log(this.formData,"传过来的值");
    },
    data() {
      return {
        drawer: true,
        formData: {
          userPhone1: null,
          userPhone2: "",
          userPhoneUnreal: "",
          userPhoneUnreal1: '',
          userPhoneUnreal2: '',
          displayRealNumber: true
        },
      }
    },
    mounted() {
      this.getCustFamily();
    },
    methods: {
      confirm() {
        this.drawer = false;
        this.handleClose()
      },
      cancelForm() {
        this.drawer = false;
        clearTimeout(this.timer);
      },
      handleClose() {

        this.drawer = false;
        this.$emit('closeD', false)
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .details2 {

    ::v-deep .el-drawer .el-drawer__body {
      padding: 0 16px;
      background-color: #fff;
      position: relative;
    }

    ::v-deep .el-drawer .el-drawer__header {
      background-color: #fff;
    }

    ::v-deep .el-drawer__container {
      position: relative;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      background: aliceblue;
      background-color: rgb(38 38 38 / 70%);
    }

    #containt .table-detail {
      border-collapse: collapse;
      font-size: 12px;
      border: 1px solid #ededed;
    }

    .btn {
      text-align: center;
    }

    //   3个标签
    .information {
      padding: 2px 10px;
      background-color: #E1F2FF;
      color: #268AEA;
      border-radius: 3px;
      margin: 0 5px;
      font-size: 15px;
    }

    //   每个分支
    .d-item {
      border: 1px solid #ededed;
      padding-bottom: 5px;

      .title b {
        display: inline-block;
        line-height: 20px;
        font-size: 13px;
        font-weight: 600;
        margin-right: 84px;
        vertical-align: middle;
        color: rgb(42, 100, 148);
        position: relative;
        z-index: 2;
        background: rgba(42, 100, 148, 0.16);
        margin-left: 0px;
        margin-bottom: 8px;
        padding-left: 12px;
        padding-right: 14px;
        border-radius: 0px 28px 28px 0px;
      }

      .table-detail tr {
        margin-bottom: 20px;
        display: block;

        th {
          font-weight: 400;
          text-align: right;
          width: 7vw !important;
          font-size: 12px;
          position: relative;
          padding: 0 5px 0 4px;
          color: rgba(86, 86, 86, 0.96);
        }

        td {
          font-weight: 400;
          // text-align: right;
          width: 10vw !important;
          font-size: 12px;
          position: relative;
          padding: 0 0px 0 4px;
          color: rgba(0, 0, 0, );
        }
      }
    }

    ::v-deep .el-image__preview {
      width: 60px !important;
      height: 60px !important;
    }

    .pic_main {
      display: flex;
      margin-left: 20px;
      margin-top: 10px;

      .pic_item {
        display: flex;
        margin-right: 40px;

        span {
          white-space: nowrap;
          line-height: 60px;
          font-size: 12px;
          color: rgba(86, 86, 86, 0.96);
          font-weight: 400;

        }
      }
    }

    // 本单费用位置
    .expense {
      position: absolute;
      // right: 20%;
      left: 13vw;
      margin-top: 5px;
      color: #00c4b3;
      font-size: 13px;
    }

    // 滚动条样式

    /* 滚动条 */
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    /* 滚动槽 */
    ::-webkit-scrollbar-track {
      border-radius: 0px;
      // background: rgba(224, 7, 7, 0.05);
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
      border-radius: 00px;
      background: #cfcece;
    }

    // 步骤条 圆的位置
    ::v-deep .el-timeline-item__node--normal {
      left: 0px !important;
      width: 12px;
      height: 12px;
    }

    ::v-deep .el-step__title {
      font-size: 13px !important;
      line-height: 38px;
    }
  }

  .Instructions {
    text-decoration: underline;
    color: #00c4b3;
    margin-left: 5px;
  }

  ::v-deep .el-radio {
    width: 65px;
  }

  .el-cascader-panel {
    .el-radio__inner {
      border: 0px;
      background: transparent;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background: none;
    }


  }
  </style>
